__turbopack_context__.v({
  "burger": "Burger-module-scss-module__Zq-6CG__burger",
  "stack-module-0": "Burger-module-scss-module__Zq-6CG__stack-module-0",
  "stack-module-1": "Burger-module-scss-module__Zq-6CG__stack-module-1",
  "stack-module-10": "Burger-module-scss-module__Zq-6CG__stack-module-10",
  "stack-module-11": "Burger-module-scss-module__Zq-6CG__stack-module-11",
  "stack-module-12": "Burger-module-scss-module__Zq-6CG__stack-module-12",
  "stack-module-13": "Burger-module-scss-module__Zq-6CG__stack-module-13",
  "stack-module-14": "Burger-module-scss-module__Zq-6CG__stack-module-14",
  "stack-module-15": "Burger-module-scss-module__Zq-6CG__stack-module-15",
  "stack-module-16": "Burger-module-scss-module__Zq-6CG__stack-module-16",
  "stack-module-17": "Burger-module-scss-module__Zq-6CG__stack-module-17",
  "stack-module-18": "Burger-module-scss-module__Zq-6CG__stack-module-18",
  "stack-module-19": "Burger-module-scss-module__Zq-6CG__stack-module-19",
  "stack-module-2": "Burger-module-scss-module__Zq-6CG__stack-module-2",
  "stack-module-20": "Burger-module-scss-module__Zq-6CG__stack-module-20",
  "stack-module-3": "Burger-module-scss-module__Zq-6CG__stack-module-3",
  "stack-module-4": "Burger-module-scss-module__Zq-6CG__stack-module-4",
  "stack-module-5": "Burger-module-scss-module__Zq-6CG__stack-module-5",
  "stack-module-6": "Burger-module-scss-module__Zq-6CG__stack-module-6",
  "stack-module-7": "Burger-module-scss-module__Zq-6CG__stack-module-7",
  "stack-module-8": "Burger-module-scss-module__Zq-6CG__stack-module-8",
  "stack-module-9": "Burger-module-scss-module__Zq-6CG__stack-module-9",
  "z-base": "Burger-module-scss-module__Zq-6CG__z-base",
  "z-content": "Burger-module-scss-module__Zq-6CG__z-content",
  "z-footer": "Burger-module-scss-module__Zq-6CG__z-footer",
  "z-header": "Burger-module-scss-module__Zq-6CG__z-header",
  "z-hero": "Burger-module-scss-module__Zq-6CG__z-hero",
  "z-logo": "Burger-module-scss-module__Zq-6CG__z-logo",
  "z-logo-effect": "Burger-module-scss-module__Zq-6CG__z-logo-effect",
  "z-navigation": "Burger-module-scss-module__Zq-6CG__z-navigation",
  "z-sub": "Burger-module-scss-module__Zq-6CG__z-sub",
});
